"use strict";
/**
 * Time-Off Request Response Types
 *
 * API response contracts for time-off request endpoints.
 *
 * @example GET /api/time-off-requests
 * @example GET /api/time-off-requests/collaborators/time-off-overview/:id
 */
Object.defineProperty(exports, "__esModule", { value: true });
